<template>
  <div
    class="questionsAndAnswers_wrap sensors_exposure"
    :style="{ backgroundImage: `url(${moduleIconUrl})` }"
    sensorsname="QAModuleExposure"
    :sensorsdata="
      JSON.stringify({
        moduleName: `${componentConfig.sort}|${componentConfig.type}`,
        contentName: componentConfig?.title,
      })
    "
  >
    <div class="header">
      <div>
        <span
          class="header_title"
          :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
          >{{ componentConfig?.title }}</span
        >
        <span
          class="header_desc"
          :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
          >{{ componentConfig?.subtitle }}</span
        >
      </div>
      <div
        class="header_btn"
        :style="{ background: buttonColor }"
        @click="toqaList"
      >
        查看更多
      </div>
    </div>
    <div class="content" v-if="loading && qaList?.length === 0">
      <div class="empty" v-for="(e, eI) in 2" :key="eI">
        <div class="skeleton"></div>
      </div>
    </div>
    <Empty text="暂无问答" v-else-if="!loading && qaList?.length === 0" />
    <template v-for="(item, index) in qaList" v-else>
      <div
        :key="index"
        class="sensors_exposure"
        sensorsname="PostExposure"
        :sensorsdata="JSON.stringify(item.sensorsdata)"
      >
        <QaCard :itemData="item" type="1" />
      </div>
    </template>
    <div class="toQuestions" @click="toQuestion">我也要提问</div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import QaCard from "../common/qaCard.vue";
import Empty from "../common/EmptyData.vue";
export default {
  name: "QuestionsAndAnswers",
  components: {
    QaCard,
    Empty,
  },
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      qaList: [],
    };
  },
  computed: {
    ...mapState(["commonStore"]),
    backgroundConfigDTO(){
      return this.componentConfig.backgroundConfigDTO
    },
    buttonColor(){
      return this.backgroundConfigDTO?.buttonColor||this.pageConfig.buttonColor
    },
    moduleIconUrl(){
      if(this.commonStore.isForPC){
        return this.backgroundConfigDTO?.moduleIconPcUrl||this.pageConfig.moduleIconPcUrl
      }else{
        return this.backgroundConfigDTO?.moduleIconUrl||this.pageConfig.moduleIconUrl
      }
    },
  },
  methods: {
    toQuestion() {
      if (!this.$base.checkLoginStatus(true)) return;
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_qa_ask",
      });
      this.$router.push({
        path: "/askQuestion",
        query: {
          activityId: this.$route.params.pageId,
          type: 1,
          componentId: this.componentConfig?.id,
        },
      });
    },
    toqaList() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_qa_more",
      });

      if (!this.$base.checkLoginStatus(true)) return;
      // 1-活动下的问答；2-公司下的问答；3-职位下的问答
      this.$router.push({
        path: "/questionAndAnswerList",
        query: {
          id: this.componentConfig?.id,
          activityId: this.$route.params.pageId,
          componentId: this.componentConfig?.id,
          type: 1,
        },
      });
    },
    async getQuestionList() {
      this.loading = true;
      const params = {
        componentId: this.componentConfig?.id,
        pageSize: this.componentConfig?.threadNumber || 3,
        type: 1,
        pageNum: 1,
        sortType: [3, 2, 1],
      };
      const res = await this.$api.activity.getQuestionList(params);
      if (+res?.code == "0" && res?.data) {
        const { questionMap = {} } = res.data || {};
        const { questionInfoList } =
          questionMap[this.componentConfig?.id] || {};
        const result = questionInfoList || [];
        this.qaList = result.map((item, index) => {
          return {
            ...item,
            sensorsdata: {
              companyId:
                item.relationType == 2
                  ? item?.companyInfo?.coId
                  : item.jobInfo?.coId,
              jobId: item.jobInfo?.jobId,
              contentId: item.id,
              contentRank: index,
            },
          };
        });
        this.loading = false;
      } else {
        // this.$toast.fail(res?.msg);
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getQuestionList();
  },
};
</script>
<style src="./index.less" scoped lang="less" />
